<template>
  <div class="change-product" :class="show ? 'show' : 'hide'" v-clickoutside="changeShowProduct">
    <div class="product" v-for="item in products" :key="item.key">
      <div>
        <svg-icon :name="item.key" style="font-size: 28px"></svg-icon>
        <div class="name">{{ item.name }}</div>
        <el-button size="mini" :class="item.permission ? 'confirm-btn-plain' : 'disable-btn'" @click="goProduct(item)">
          <svg-icon name="lock" v-if="!item.permission"></svg-icon>
           {{ $t('header.enter') }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
export default {
  name: 'ChangeProduct',
  directives: { Clickoutside },
  data() {
    return {
      langShow: localStorage.getItem('language') == 'en' ? false : true,
      getRulse:null,
      products: [],
    }
  },
  computed: {
    // products(){
    //   let data = localStorage.getItem('set_account_info') ? JSON.parse(localStorage.getItem('set_account_info')).products : []
    //   let pro = this.$util.judgeOrigin()
    //   console.log(pro, 'loo');
    //   //判断当前是否是土耳其
    //   if(pro=='TR') {
    //     let origin = location.origin.indexOf('localhost')>=0 ? 'https://export.bilvio.com' : location.origin
    //     //判断
    //     data = data.filter(item=>['gt5', 'yisou3'].includes(item.key))
    //     console.log(data, 'ooo3w');
    //   } else if(['EC', 'JM'].includes(pro)) {
    //     data = data.filter(item=>['gt5'].includes(item.key))
    //   }
    //   return data
    // },
    accountInfo() {
      return localStorage.getItem("set_account_info")?JSON.parse(localStorage.getItem("set_account_info")):this.$store.getters.accountInfo;
    },
    show() {
      return this.$store.getters.showProduct
    },
  },
  watch: {
    'accountInfo.products': {
      handler(val) {
        this.handleGetProducts(val)
      },
      immediate: true,
    },
  },
  created(){
    window.addEventListener("setItemEvent",(e) => {
      if(e.key == 'gt6_getRules') {
        this.getRulse=JSON.parse(e.newValue)
      }
    })
  },
  methods: {
    changeShowProduct(e) {
      if (this.show) {
        setTimeout(() => {
          this.$store.commit('change_show_product', false)
        }, 1)
      }
    },
    // 重新定义菜单
    handleGetProducts(val) {
      let data = val || []
      let pro = this.$util.judgeOrigin()
      //判断当前是否是土耳其
      if(['TR'].includes(pro)) {
        let origin = location.origin.indexOf('localhost')>=0 ? 'https://export.bilvio.com' : location.origin
        //判断
        data = data.filter(item=>['gt6','gt5', 'yisou3'].includes(item.key))
      } else if(['EC'].includes(pro)) {
        //判断
        data = data.filter(item=>['gt6','gt5', 'yisou3', 'crm'].includes(item.key))
      } else if(['JM'].includes(pro)) {
        data = data.filter(item=>['gt5'].includes(item.key))
      }
      this.products = data
    },
    goProduct(item) {
      if (item.permission) {
        // window.open(item.url)
        const link = document.createElement('a');
        let time = new Date().getTime()
        if(item.url.indexOf("?")>0) {
          link.href = `${item.url}&t=${time}`
        } else {
          link.href = `${item.url}?t=${time}`
        }
        link.target='_blank'
        link.style.display = 'none';
        const elementA = document.querySelector('.product');
        elementA?.append(link);
        link.click();
        elementA?.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        this.$store.commit('change_show_product', false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.change-product {
  display: flex;
  position: fixed;
  width: 100%;
  background-color: #ffffff;
  z-index: 98;
  height: 180px;
  align-items: center;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
  transition: top 0.3s;
  &.show {
    top: 60px;
    z-index: 999;
  }
  &.hide {
    top: -125px;
    z-index: 999;
  }
  .product {
    flex: 1;
    text-align: center;
    position: relative;
    &::after {
      content: ' ';
      display: block;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 62px;
      background-color: $--color-border-lighter;
    }
    .name {
      margin-bottom: 36px;
      margin-top: 20px;
    }
  }
}
</style>
